import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { XInput } from '@xui/components';
import { VxeUI, VxeFormItem } from 'vxe-pc-ui';
import { computed } from 'vue';
export default {
  __name: 'xInputDesignView',
  props: {
    renderOpts: {
      type: Object,
      default: () => ({})
    },
    renderParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const {
      useWidgetView
    } = VxeUI.formDesign;
    const props = __props;
    const {
      currWidget,
      widgetModel
    } = useWidgetView(props);
    const inputProps = computed(() => {
      return {
        placeholder: currWidget?.options?.placeholder || '',
        maxLength: currWidget?.options?.maxLength || '',
        showWordCount: currWidget?.options?.showWordCount || false,
        readonly: currWidget?.options?.readonly || false,
        disabled: currWidget?.options?.disabled || false
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(VxeFormItem), {
        field: _unref(currWidget).field,
        title: _unref(currWidget).title
      }, {
        default: _withCtx(() => [_createVNode(_unref(XInput), _mergeProps({
          modelValue: _unref(widgetModel),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(widgetModel) ? widgetModel.value = $event : null)
        }, inputProps.value), null, 16, ["modelValue"])]),
        _: 1
      }, 8, ["field", "title"]);
    };
  }
};